import React, { useEffect, useState } from "react";
import axios from "../api/api";

export default function Comments({ blogId }) {
  const [comments, setComments] = useState([]);
  const [form, setForm] = useState({ name: "", comment: "" });
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const loadComments = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/blog/${blogId}/comments`);
      setComments(res.data);
    } catch (err) {
      console.error("Failed to load comments:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (blogId) loadComments();
  }, [blogId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.comment.trim()) {
      return alert("Please fill in both name and comment");
    }

    try {
      setSubmitting(true);
      await axios.post(`/blog/${blogId}/comments`, form);
      setForm({ name: "", comment: "" });
      loadComments();
    } catch (err) {
      console.error("Failed to post comment:", err);
      alert("Failed to post comment. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mt-10">
      <h3 className="font-semibold mb-3">
        {loading ? "Loading..." : `${comments.length} Comments`}
      </h3>

      <form onSubmit={handleSubmit} className="mb-4">
        <input
          className="border p-2 w-full mb-2"
          placeholder="Your name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          disabled={submitting}
        />
        <textarea
          className="border p-2 w-full mb-2"
          placeholder="Write a comment"
          value={form.comment}
          onChange={(e) => setForm({ ...form, comment: e.target.value })}
          disabled={submitting}
        />
        <button
          type="submit"
          className={`px-3 py-2 rounded text-white ${
            submitting ? "bg-indigo-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
          }`}
          disabled={submitting}
        >
          {submitting ? "Posting..." : "Post"}
        </button>
      </form>

      <div className="space-y-3">
        {comments.map((c) => (
          <div key={c.id} className="p-3 bg-gray-50 rounded">
            <div className="font-semibold">{c.name}</div>
            <div>{c.comment}</div>
            <div className="text-xs text-gray-400">
              {new Date(c.createdAt).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
